import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=8747a9b4&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8747a9b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8747a9b4')) {
      api.createRecord('8747a9b4', component.options)
    } else {
      api.reload('8747a9b4', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=8747a9b4&scoped=true&", function () {
      api.rerender('8747a9b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/editor/editor.vue"
export default component.exports